import { render, staticRenderFns } from "./PendingPaymentInvestments.vue?vue&type=template&id=77eb711a&"
import script from "./PendingPaymentInvestments.vue?vue&type=script&lang=js&"
export * from "./PendingPaymentInvestments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports